import { Icon } from '@/shared/ui/Icon';

import { DATA_ZONE_COLOR_MAP, type DataZoneLowerCaseString } from '@/entities/quality';

import { formatDataZone } from '@/features/quality/lib';

import styles from './DataZoneTableCell.module.css';

type DataZoneTableCellProps = {
  dataZone: DataZoneLowerCaseString;
};

export const DataZoneTableCell = ({ dataZone }: DataZoneTableCellProps) => {
  const formattedDataZone = formatDataZone(dataZone);
  return (
    <div className={styles.cell}>
      <Icon name="gem" size={16} color={DATA_ZONE_COLOR_MAP[formattedDataZone]} />
      {formattedDataZone}
    </div>
  );
};
